module.exports = __webpack_public_path__ + "static/media/min-1600-hero.459728cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/min-1600-hero.jpg
// module id = 43
// module chunks = 0